const branding = {
  platformName: process.env.REACT_APP_PLATFORM_NAME || "GloCal Angel Network",
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || "#0047AB",
  primaryHover: process.env.REACT_APP_PRIMARY_HOVER || "#003580",
};

export default branding;
